import axios from 'axios';
import { Box, Grid, Container, CircularProgress, Backdrop, Button } from '@material-ui/core';
import { getAPIUrl, isValidEmail } from '../../helpers/CommonHelper';
import { withRouter } from "react-router-dom";
import { Form } from 'react-bootstrap';
import React, { PureComponent } from 'react';
import logo from '../../assets/XpressPac-logo-Original.png';
import '../../styles/Login.css';

class LoginComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false
    };
  }
  
  componentDidMount() {
    const { cookies } = this.props;
    const token = cookies.get('token');
    if (token) {
      this.props.history.replace("/admin/dashboard");
    }
  }

  inputChanged = (value, key) => {
    this.setState({
      [key]: value,
    });
  }

  handleSubmit = () => {
    if (this.state.email == undefined
      || this.state.password == undefined
    ) {
      alert('One or more field is missing');
      return;
    }

    if (!isValidEmail(this.state.email)) {
      alert('Email is invalid');
      return;
    }

    this.setState({
      isLoading: true,
    });

    axios.post(`${getAPIUrl()}/admin/login`, {
      emailId: this.state.email,
      password: this.state.password,
    }, {
      timeout: 30000,
    }).then((resp) => {
      this.setState({
        isLoading: false,
      });
      const { cookies } = this.props;
      //setting a cookie
      cookies.set('token', resp.data.data.token, { path: '/', expires: new Date(new Date().getTime() + 90 * 24 * 3600 * 1000) });

      // go to dashboard
      this.props.history.push("/admin/dashboard");
    }).catch((error) => {
      console.error(error);
      this.setState({
        isLoading: false,
      });
      if (error.response && error.response.status === 400) {
        alert(error.response.data.message);
      } else {
        alert('Something went wrong!!!');
      }
    });
  }

  render() {
    return (
      <Box>
        <Container>
          <Grid container className="container-min-height" direction="row" justify="center" alignItems="center">
            <Grid item xs={12} sm={4} md={4}>
              <Form>
                <img src={logo} />
                <Form.Group>
                  <Form.Control
                    type="email"
                    placeholder="Email"
                    required
                    onChange={(event) => this.inputChanged(event.target.value, 'email')}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Control
                    type="password"
                    placeholder="Password"
                    required
                    onChange={(event) => this.inputChanged(event.target.value, 'password')}
                  />
                </Form.Group>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.handleSubmit}>
                  Login
                </Button>
              </Form>
            </Grid>
          </Grid>
          <Backdrop className="loading-indicator" open={this.state.isLoading}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </Container>
      </Box>
    )
  }
}

export default withRouter(LoginComponent);
